import React from 'react'
import _ from 'lodash'


import AssetsDeclaration from './AssetsDeclaration'
import TaxpayerIdentification from './TaxpayerIdentification'
import NoDataFoundMessage from '../NoDataFoundMessage'
import DebtsAndEncumbrances from './DebtsAndEncumbrances'
import SubsectionedIncome from './Income/SubsectionedIncome'
import SingleTableIncome from './Income/SingleTableIncome'
import IncomeFromIndividual from './IncomeFromIndividual'

const IrValues = ({ irDeclaration, onDeclarationCheck, readOnly }) => {
  return (
    <div style={{ width: '100%' }}>
      <div>
        <h2>
          <ul>
            <li>Arquivo de Declaração</li>
          </ul>
        </h2>
      </div>
      <br />
      <div>
        {_.isEmpty(irDeclaration) ? <NoDataFoundMessage message='Arquivo de declaração não enviado' /> : (
          <div className='values-files-container'>
            <TaxpayerIdentification irDeclaration={irDeclaration} />
            <AssetsDeclaration irDeclaration={irDeclaration} onDeclarationCheck={onDeclarationCheck} readOnly={readOnly} />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_holder' />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_dependents' />
            <br />
            <IncomeFromIndividual irDeclaration={irDeclaration} sectionId='income_from_individual_to_holder' />
            <br />
            <IncomeFromIndividual irDeclaration={irDeclaration} sectionId='income_from_individual_to_dependents' />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='exempt_income' />
            <br />
            <SubsectionedIncome irDeclaration={irDeclaration} sectionId='exclusive_taxation_income' />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_holder_with_suspended_requirements' />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='income_from_legal_person_to_dependents_with_suspended_requirements' />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='accumulated_income_from_legal_person_to_holder' />
            <br />
            <SingleTableIncome irDeclaration={irDeclaration} sectionId='accumulated_income_from_legal_person_to_dependents' />
            <br />
            <DebtsAndEncumbrances irDeclaration={irDeclaration} />
            <br />
          </div>
        )}

      </div>
    </div>
  )
}

export default IrValues
